import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { getSupportUrl } from '@/utils/urls';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    variant: 'desktop' | 'mobile';
};

export const HowToWinHelpCenter = ({ variant }: Props) => {
    const { formatMessage } = useIntl();
    const isMobile = variant === 'mobile';

    const description = formatMessage({ id: 'howToWinRedesigned.helpCenter.description' });
    const ctaText = formatMessage({ id: 'howToWinRedesigned.helpCenter.cta' });

    return (
        <section
            className={cn('flex flex-col gap-sm rounded-lg bg-background-subdued px-sm py-md', {
                'mx-auto w-full max-w-[1596px] items-center justify-center smMin:flex-row': !isMobile,
                'mx-sm items-start gap-md p-sm': isMobile,
            })}
            data-testid={`howToWinHelpCenter-${variant}`}
        >
            <BodyPrimary>{description}</BodyPrimary>
            <Button
                as="a"
                href={getSupportUrl()}
                rel="noreferrer"
                size="md"
                style="primary"
                target="_blank"
                variant="outlined"
            >
                {ctaText}
            </Button>
        </section>
    );
};
